import _flatten from 'lodash/flatten';
import { atom } from 'jotai';
import { getPresetSize } from '../containers/Packages/utils';
import {
  Item,
  Parcel,
  Address,
  HoldAtLocation,
  ShipmentType,
  AddressType,
  ItemType,
  Shipment,
  Incoterm,
} from '../types/common';
import { convertDocumentToItems } from '../utils/helpers';

const documentPreset = getPresetSize('envelope', ShipmentType.DOCUMENT);

const initAddress = {
  name: '',
  phone: '',
  dialCode: '',
  street: '',
  city: '',
  type: 'RESIDENTIAL' as AddressType,
};

export const originCountryBaseAtom = atom<string>('');

export const originCountryAtom = atom<string, string>(
  (get) => get(originCountryBaseAtom),
  (_, set, value) => {
    set(originAddressAtom, initAddress);
    set(originCountryBaseAtom, value);
  },
);

export const originAddressAtom = atom<Address>(initAddress);

export const destinationCountryBaseAtom = atom<string>('');

export const destinationCountryAtom = atom<string, string>(
  (get) => get(destinationCountryBaseAtom),
  (_, set, value) => {
    set(destinationAddressAtom, initAddress);
    set(destinationCountryBaseAtom, value);
  },
);

export const destinationAddressAtom = atom<Address>(initAddress);

export const holdAtLocationAtom = atom<HoldAtLocation | null>(null);

export const typeAtom = atom<ShipmentType>(ShipmentType.PARCEL);

export const documentAtom = atom<string>('');

export const parcelsAtom = atom<string[]>([]);

export const parcelMapAtom = atom<Record<string, Parcel>>({});

export const parcelItemsAtom = atom<Record<string, string[]>>({});

export const itemMapAtom = atom<Record<string, Item>>({});

export const serviceBaseAtom = atom<string>('');

export const serviceAtom = atom<string, string>(
  (get) => get(serviceBaseAtom),
  (_, set, value) => {
    set(holdAtLocationAtom, null);
    set(serviceBaseAtom, value);
  },
);

export const itemTypeAtom = atom<ItemType>(ItemType.PERSONAL_USE);

export const incotermAtom = atom<Incoterm>(Incoterm.DDU);

const shipmentAtom = atom<Shipment>((get) => ({
  originCountry: get(originCountryAtom),
  originAddress: get(originAddressAtom),
  destinationCountry: get(destinationCountryAtom),
  destinationAddress: get(destinationAddressAtom),
  holdAtLocation: get(holdAtLocationAtom),
  type: get(typeAtom),
  parcels:
    get(typeAtom) === ShipmentType.DOCUMENT
      ? [documentPreset]
      : get(parcelsAtom).map((parcelId) => get(parcelMapAtom)[parcelId]),
  items:
    get(typeAtom) === ShipmentType.DOCUMENT
      ? convertDocumentToItems(get(documentAtom))
      : _flatten(get(parcelsAtom).map((parcelId) => get(parcelItemsAtom)[parcelId]))
          .filter(Boolean)
          .map((itemId) => get(itemMapAtom)[itemId]),
  parcelsInfo:
    get(typeAtom) === ShipmentType.DOCUMENT
      ? convertDocumentToItems(get(documentAtom))
      : get(parcelsAtom).map((parcelId) =>
          get(parcelItemsAtom)[parcelId]?.map((itemId) => get(itemMapAtom)[itemId]),
        ),
  service: get(serviceAtom),
  itemType: get(itemTypeAtom),
  incoterm: get(incotermAtom),
}));

export default shipmentAtom;
